import React from 'react';
import BaseComponent from './BaseComponent';

export default function FieldInfo({ style, ...rest }) {
    return (
        <BaseComponent style={{ marginTop: 0, fontSize: '.8em', ...style }} {...rest}/>
    );
}

FieldInfo.defaultProps = {
    as: 'p'
};
